'use strict';

exports.__esModule = true;
exports.get = get;

var _http = require('./../network/http');

var API = { SETTINGS: '/settings' };

var settings = {
  get: get
};

exports.default = settings;

/**
 * Wrapper for `/settings` API endpoint
 */

/**
 * Get all quiqup settings (e.g. opening hours)
 * @returns {promise} containing the entity object of the settings
 */

function get() {
  return (0, _http.get)(API.SETTINGS);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/settings/settings.js
// module id = 1099
// module chunks = 0